import TextInput from "Components/molecule/inputs/text-input"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import FormProps from "data/forms"
import DepartmentLevelFields from "./types"

const DESCRIPTION_KEY = 'description'
const DEPTH_KEY = 'depth'

const DepartmentLevelForm = ({
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    isValid,
    touched,
    isSubmitting,
    edit
}: FormProps<DepartmentLevelFields>) => {

    return <div className="generate-documents-form">
        <TextInput
            touched={!!touched.description}
            name={DESCRIPTION_KEY}
            key={DESCRIPTION_KEY}
            label={"Description*"}
            placeholder={"Department Level Description"}
            value={values.description}
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!touched.description && !!errors.description}
            message={touched.description ? errors.description : undefined}
        />

        <TextInput
            type="number"
            touched={!!touched.depth}
            name={DEPTH_KEY}
            key={DEPTH_KEY}
            label={"Depth*"}
            placeholder={"1 = Company, 2 = Division, 3 = Department"}
            value={values.depth}
            onBlur={handleBlur}
            onChange={handleChange}
            error={!!touched.depth && !!errors.depth}
            message={touched.depth ? errors.depth : undefined}
        />

        <PrimaryButton
            type='submit'
            onClick={() => handleSubmit()}
            disabled={isSubmitting || !isValid}
            className="w-100"
        >
            {isSubmitting ? "Submitting...." : edit ? "Update" : "Submit"}
        </PrimaryButton>
    </div>
}

export default DepartmentLevelForm
